import { Component, Input } from '@angular/core';
import { WxrlAuthor } from '../../services/wxrl-rules.service';

/**
 * Componente reutilizable para mostrar información de autores (creación y modificación).
 *
 * @component
 * @selector afoone-wxrl-authors
 */
@Component({
  selector: 'afoone-wxrl-authors',
  templateUrl: './wxrl-authors.component.html',
  styleUrls: ['./wxrl-authors.component.css'],
})
export class WxrlAuthorsComponent {
  /**
   * Autor de creación
   */
  @Input() createdBy: WxrlAuthor | null = null;

  /**
   * Fecha de creación
   */
  @Input() createdWhen: string | Date | null = null;

  /**
   * Autor de modificación
   */
  @Input() modifiedBy: WxrlAuthor | null = null;

  /**
   * Fecha de modificación
   */
  @Input() modifiedWhen: string | Date | null = null;

  /**
   * Determina si debe mostrarse la sección de modificación.
   * Solo se muestra si hay datos explícitos de modificación (modifiedBy o modifiedWhen).
   */
  get shouldShowModified(): boolean {
    return !!(this.modifiedBy || this.modifiedWhen);
  }

  /**
   * Autor de modificación (solo si está presente explícitamente)
   */
  get displayModifiedBy(): WxrlAuthor | null {
    return this.modifiedBy;
  }

  /**
   * Fecha de modificación (solo si está presente explícitamente)
   */
  get displayModifiedWhen(): string | Date | null {
    return this.modifiedWhen;
  }

  /**
   * Formatea el nombre del autor
   */
  getAuthorName(author: WxrlAuthor | Record<string, unknown> | null): string {
    if (!author) return '';
    const name = String(author.Name ?? author['name'] ?? '').trim();
    const kurzName = String(author.KurzName ?? author['lastName'] ?? '').trim();
    return `${name} ${kurzName}`.trim();
  }

  hasAuthorName(author: WxrlAuthor | Record<string, unknown> | null): boolean {
    return this.getAuthorName(author).length > 0;
  }
}

